import api from '@/shared/api/client';

/**
 * Pilotage des actifs (réservé à la capacité PILOTAGE côté API).
 *
 * Le catalogue d'actions n'est PAS en dur ici : il vient de `/pilotage/actions`.
 * Ajouter une action au backend suffit donc à la faire apparaître dans l'UI, et une
 * action retirée disparaît — les deux ne peuvent pas diverger.
 */

export const fetchPilotageActions = () => api.get('/pilotage/actions').then(r => r.data);

export const fetchPilotageAssets = (params) =>
  api.get('/pilotage/assets', { params }).then(r => r.data);

export const fetchPilotageAsset = (assetId) =>
  api.get(`/pilotage/asset/${assetId}`).then(r => r.data);

export const fetchPilotageJournal = (limit = 100) =>
  api.get('/pilotage/journal', { params: { limit } }).then(r => r.data);

/**
 * Exécute une action sur UN actif.
 *
 * Renvoie `{ success, action, detail, simulated, error }`. `success: false` n'est pas
 * une erreur HTTP : l'ordre a bien été traité, c'est le matériel qui n'a pas suivi.
 */
export const executeAssetAction = (assetId, action, value = null) =>
  api.post(`/pilotage/asset/${assetId}/action`, { action, value }).then(r => r.data);

/**
 * Où en est un ordre S-Miles : `{ resultat, libelle, confirme_a }`.
 * `resultat` vaut en_attente · reussi · echoue · sans_reponse. Lu en base, gratuit.
 */
export const fetchEtatOrdre = (operation) =>
  api.get(`/pilotage/ordres/${encodeURIComponent(operation)}`).then(r => r.data);
